import Vue from 'vue'

export const JustDigits = () => {
    Vue.directive('digitsonly', (el, binding) => {
        const newValue = el.value.replace(/[a-zA-Z]/ig, '')

        el.value = newValue
        binding.value = el.value
    })
}
